
import { Stack, Typography } from '@mui/material';
import * as Icons from '../../icons';

interface FileStatusMessageProps {
  type: 'error' | 'success';
  message: string;
}

const stackStyles = {
  direction: 'row' as const,
  spacing: 1,
  alignItems: 'center',
  sx: { mt: 1, justifyContent: 'center' },
};

const iconStyles = { fontSize: { xs: 18, sm: 20 } };
const textStyles = { fontSize: { xs: '0.75rem', sm: '0.875rem' }, textAlign: 'center' as const };

export const FileStatusMessage = ({ type, message }: FileStatusMessageProps) => {
  const isError = type === 'error';
  const Icon = isError ? Icons.Error : Icons.CheckCircle;
  const iconColor = isError ? 'error' : 'success';
  const textColor = isError ? 'error' : 'success.main';

  return (
    <Stack {...stackStyles}>
      <Icon color={iconColor} sx={iconStyles} />
      <Typography variant="body2" color={textColor} sx={textStyles}>
        {message}
      </Typography>
    </Stack>
  );
};
